import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { MainContext } from "../../../MainContext";
import { DarkModeButton } from "./DarkModeButton";
import { request } from "../../../request";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Flag from "react-world-flags";
import "./NavBar.scss";

const all_pages = [
    { name: "Wallet", location: "/wallet", key: "account" },
    { name: "Transactions", location: "/transactions", key: "transaction" },
    { name: "Customers", location: "/customers", key: "customer" },
    { name: "History", location: "/history", key: "history" },
    // { name: "Automation", location: "/automation", key: "automation" },
    { name: "Users", location: "/users", key: "user" },
];
const NavBar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { darkMode, formatNumber, token, capital, premissions, language, switchLanguage, texts } = useContext(MainContext);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [pages, setPages] = useState([]);
    const [capitalCpllapsed, setCapitalCollapsed] = useState(true);
    const [hidePass, setHidePass] = useState(false);
    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const logOut = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to log out?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.removeItem("token");
                localStorage.removeItem("premissions");
                navigate("/login");
            }
        });
    };

    const reloadPage = () => {
        window.location.reload();
    };

    useEffect(() => {
        const newPages = [];
        Object.entries(premissions).map(([key, value]) => {
            if (value.default) {
                newPages.push(all_pages.find((p) => p.key === key));
            }
        });
        setPages(newPages);
    }, [premissions]);

    const isLoginPage = location.pathname === "/login";
    const isWebsite = location.pathname === "/website";

    return (
        <header style={{ backgroundColor: darkMode ? "black" : "white" }} className="desktop-navbar fixed top-0 lg:flex items-center justify-between whitespace-nowrap border-b border-solid border-b-[#f0f2f4] px-10 py-3">
            <div className="flex items-center gap-4 text-[#111418]">
                {/* <div className="size-2 w-12 h-12" onClick={() => reloadPage()}>
                    <img src="/img/logo.png" alt="CryptoTracker Logo" className="w-full h-full" />
                </div> */}
                <h2 className="text-lg font-bold leading-tight tracking-[-0.015em]" style={{ color: darkMode ? "white" : "#111418" }}>
                    CryptoTracker Club
                </h2>
            </div>
            {!isWebsite && !isLoginPage && premissions?.account?.capital && (
                <div onMouseLeave={() => setCapitalCollapsed(true)} className="capital-container">
                    <div onClick={() => setCapitalCollapsed(!capitalCpllapsed)} className="main">
                        {hidePass ? (
                            <>
                                <p>{capital.capital} Դ</p>
                                {capitalCpllapsed ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                                <VisibilityOffIcon onClick={() => setHidePass((prev) => !prev)} />
                            </>
                        ) : (
                            <>
                                <p>************</p>
                                {<KeyboardArrowDownIcon disablePointerEvents />}
                                <VisibilityIcon onClick={(prev) => setHidePass((prev) => !prev)} />
                            </>
                        )}
                    </div>
                    <>
                        {hidePass ? (
                            <div style={{ opacity: capitalCpllapsed ? "" : "1" }} className="rest">
                                {capital.allAmount.map((curr) => {
                                    return (
                                        <div>
                                            <p>
                                                {curr.currency_name}: {curr.value} ({curr.avg.toFixed(2)})
                                            </p>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            ""
                        )}
                    </>
                </div>
            )}
            {!isWebsite && !isLoginPage && (
                <div className="lg:flex sm:relative items-center gap-8">
                    <div className="relative">
                        {/* Toggle button for mobile */}
                        <button className="lg:hidden mt-4 block bg-[#FEC901] text-black p-2 rounded-md" onClick={toggleDropdown}>
                            Menu
                        </button>

                        {/* Dropdown menu for mobile, horizontal links for larger screens */}
                        <div className={`lg:flex items-center gap-4 ${isDropdownOpen ? "block" : "hidden"} lg:block`}>
                            {pages.map((page) => {
                                if (page) {
                                    const isActive = location.pathname === `${page?.location}`;
                                    return (
                                        <a
                                            key={page?.location}
                                            className={`flex min-w-[84px] max-w-[480px] mt-2 sm:mt-0 cursor-pointer items-center justify-center overflow-hidden rounded-xl h-8 text-sm font-medium leading-normal w-full p-5 ${
                                                isActive ? "bg-[#FEC901] text-black" : "bg-[#f0f2f4] text-black"
                                            }`}
                                            href={`#${page?.location}`}
                                            style={{ color: darkMode ? "black" : "black" }}
                                        >
                                            {texts.navbar[page.name.toLowerCase()]}
                                        </a>
                                    );
                                }
                            })}
                        </div>
                    </div>
                    <div className="language-toggle">
                        <button onClick={() => switchLanguage(language === "en" ? "ru" : "en")} className={`toggle-button ${language === "en" ? "english" : "russian"}`}>
                            {language === "en" ? (
                                <>
                                    <Flag code="US" style={{ width: "24px", height: "16px" }} />
                                    <span>English</span>
                                </>
                            ) : (
                                <>
                                    <Flag code="RU" style={{ width: "24px", height: "16px" }} />
                                    <span>Русский</span>
                                </>
                            )}
                        </button>
                    </div>
                    {/* <DarkModeButton /> */}
                    <div className="flex mt-10 sm:mt-0 items-center gap-9">
                        <a
                            className="text-[#111418] text-sm font-medium leading-normal cursor-pointer"
                            onClick={async () => {
                                const { value: formValues } = await Swal.fire({
                                    title: "Enter new password",
                                    html: `
        <input type="text" id="swal-input2" class="swal2-input" placeholder="New password">
      `,
                                    focusConfirm: false,
                                    showCancelButton: true,
                                    preConfirm: () => {
                                        const password = document.getElementById("swal-input2").value;

                                        if (!password) {
                                            Swal.showValidationMessage("Please fill both inputs");
                                            return null;
                                        }

                                        return { password };
                                    },
                                });

                                if (!formValues) return;

                                try {
                                    request.post("/user/change-password/", formValues);

                                    Swal.fire("Success!", "Your password has been changed.", "success");
                                } catch (err) {
                                    Swal.fire("Error!", "Something went wrong. You provided wrong data.", "error");
                                }
                            }}
                            style={{ color: darkMode ? "white" : "#111418" }}
                        >
                            Change password
                        </a>
                    </div>
                    <div className="flex mt-10 sm:mt-0 items-center gap-9">
                        <a className="text-[#111418] text-sm font-medium leading-normal cursor-pointer" onClick={logOut} style={{ color: darkMode ? "white" : "#111418" }}>
                            {texts.navbar.logout}
                        </a>
                    </div>
                    <div className="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10"></div>
                </div>
            )}
            {isWebsite ? (
                <div className="lg:flex sm:relative items-center gap-8">
                    <div className="relative">
                        <a
                            className={`flex min-w-[84px] max-w-[480px] mt-2 sm:mt-0 cursor-pointer items-center justify-center overflow-hidden rounded-xl h-8 text-sm font-medium leading-normal w-full p-5 ${false ? "bg-[#FEC901] text-black" : "bg-[#f0f2f4] text-black"}`}
                            href={`#/login`}
                            style={{ color: darkMode ? "black" : "black" }}
                        >
                            Login
                        </a>
                    </div>
                </div>
            ) : (
                ""
            )}
        </header>
    );
};

export default NavBar;
